// MELY theme.js — minimal, no dependencies
(function () {
  'use strict';

  const I18N = window.MELY_I18N || {};
  const t = (path, fallback) => path.split('.').reduce((obj, key) => (obj && obj[key] != null ? obj[key] : null), I18N) || fallback;

  // ── Media Slideshow ────────────────────────────────────────────────
  window.melySlide = function(id, dir) {
    var wrap = document.getElementById(id);
    if (!wrap) return;
    var all = Array.from(wrap.querySelectorAll('.media-slide'));
    var dots = wrap.querySelectorAll('.media-slide__dot');
    var visible = all.filter(function(s){ return !s.classList.contains('is-gone'); });
    if (!visible.length) return;
    var vi = visible.findIndex(function(s){ return s.classList.contains('is-active'); });
    if (vi < 0) vi = 0;
    visible[vi].classList.remove('is-active');
    var a0 = all.indexOf(visible[vi]); if (dots[a0]) dots[a0].classList.remove('is-active');
    vi = (vi + dir + visible.length) % visible.length;
    visible[vi].classList.add('is-active');
    var a1 = all.indexOf(visible[vi]); if (dots[a1]) dots[a1].classList.add('is-active');
  };
  window.melyGoTo = function(id, idx) {
    var wrap = document.getElementById(id);
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.media-slide');
    var dots = wrap.querySelectorAll('.media-slide__dot');
    if (slides[idx] && slides[idx].classList.contains('is-gone')) return;
    slides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
    dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
  };
  // Filter the gallery to show only the images of the selected colour
  window.melyFilterGallery = function(wrap, color) {
    if (!wrap) return;
    var slides = Array.from(wrap.querySelectorAll('.media-slide'));
    var dots = wrap.querySelectorAll('.media-slide__dot');
    var c = (color || '').toLowerCase().trim();
    var anyMatch = !!c && slides.some(function(s){
      var sc = (s.dataset.mediaColor || '').toLowerCase();
      return sc && (sc === c || sc.indexOf(c) > -1 || c.indexOf(sc) > -1);
    });
    slides.forEach(function(s, i){
      var sc = (s.dataset.mediaColor || '').toLowerCase();
      var show;
      if (!c || !anyMatch) show = true;        // no colour / nothing tagged → show all
      else if (!sc) show = true;               // untagged images stay visible
      else show = (sc === c || sc.indexOf(c) > -1 || c.indexOf(sc) > -1);
      s.classList.toggle('is-gone', !show);
      if (dots[i]) dots[i].classList.toggle('is-gone', !show);
    });
    var visible = slides.filter(function(s){ return !s.classList.contains('is-gone'); });
    slides.forEach(function(s){ s.classList.remove('is-active'); });
    dots.forEach(function(d){ d.classList.remove('is-active'); });
    if (visible.length) {
      visible[0].classList.add('is-active');
      var fi = slides.indexOf(visible[0]);
      if (dots[fi]) dots[fi].classList.add('is-active');
    }
  };

  // ── Sticky header — announcement hides on scroll down, returns on scroll up ──
  const header = document.querySelector('.header');
  if (header) {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY && y > 44) {
        document.documentElement.classList.add('ann-hidden');
      } else {
        document.documentElement.classList.remove('ann-hidden');
      }
      header.classList.toggle('is-scrolled', y > 8);
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Back to top ────────────────────────────────────────────────────
  const backTop = document.querySelector('.back-to-top');
  if (backTop) {
    window.addEventListener('scroll', () => backTop.classList.toggle('is-visible', window.scrollY > 600), { passive: true });
    backTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // ── Mobile drawer ──────────────────────────────────────────────────
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-drawer]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const drawerClose = document.querySelector('[data-drawer-close]');

  const openDrawer = () => {
    drawer && drawer.classList.add('is-open');
    drawerOverlay && drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    drawer && drawer.classList.remove('is-open');
    drawerOverlay && drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  menuToggle && menuToggle.addEventListener('click', openDrawer);
  drawerClose && drawerClose.addEventListener('click', closeDrawer);
  drawerOverlay && drawerOverlay.addEventListener('click', () => {
    closeDrawer();
    if (typeof closeCartDrawer === 'function') closeCartDrawer();
    if (typeof closeSearch === 'function') closeSearch();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      if (typeof closeCartDrawer === 'function') closeCartDrawer();
      if (typeof closeSearch === 'function') closeSearch();
    }
  });

  // ── Reveal on scroll ───────────────────────────────────────────────
  const revealEls = document.querySelectorAll('.reveal');
  const showAll = () => revealEls.forEach((el) => el.classList.add('is-visible'));

  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach((el) => io.observe(el));
    // Safety: immediately reveal above-fold elements
    setTimeout(() => {
      revealEls.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 80);
  } else {
    showAll();
  }

  // ── Wishlist toggle — persists {id,url,title,price,img} ──────────
  const WISH_KEY = 'mely-wishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch { return []; } };
  const saveWishlist = (list) => { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch {} };

  // Update the heart icon count badge in the header
  const updateWishCount = (list) => {
    const items = list || getWishlist();
    const n = items.length;
    document.querySelectorAll('.wish-count').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    document.querySelectorAll('.header__wishlist').forEach((el) => {
      el.classList.toggle('has-items', n > 0);
    });
  };

  // Restore wished state on load
  const wished = getWishlist();
  updateWishCount(wished);
  if (wished.length) {
    document.querySelectorAll('[data-wish]').forEach((btn) => {
      const id = btn.dataset.wishId || btn.dataset.productId;
      if (id && wished.some((w) => String(w.id || w) === String(id))) {
        btn.classList.add('is-wished');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.wishId || btn.closest('[data-product-id]')?.dataset.productId;
    btn.classList.toggle('is-wished');
    const isWished = btn.classList.contains('is-wished');
    btn.setAttribute('aria-pressed', isWished);
    if (id) {
      const list = getWishlist();
      if (isWished) {
        if (!list.some((w) => String(w.id || w) === String(id))) {
          list.push({
            id,
            url: btn.dataset.wishUrl || '',
            title: btn.dataset.wishTitle || '',
            price: btn.dataset.wishPrice || '',
            img: btn.dataset.wishImg || ''
          });
        }
      } else {
        const idx = list.findIndex((w) => String(w.id || w) === String(id));
        if (idx > -1) list.splice(idx, 1);
      }
      saveWishlist(list);
      updateWishCount(list);
    }
  });

  // ── Quick-add to cart ──────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.addToCart;
    if (!variantId) return;
    btn.textContent = '...';
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Cart add failed');
      btn.textContent = '✓ ' + t('products.added', 'Added');
      // Update cart count badge
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartRes.json();
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      setTimeout(() => { btn.textContent = t('products.addToBag', 'Add to bag'); btn.disabled = false; }, 2200);
    } catch {
      btn.textContent = t('products.addToBag', 'Add to bag');
      btn.disabled = false;
    }
    // Refresh cart drawer if open
    if (cartDrawer && cartDrawer.classList.contains('is-open')) refreshCartDrawer();
  });

  // ── Search Overlay ─────────────────────────────────────────────────
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchToggles = document.querySelectorAll('[data-search-toggle]');
  const searchClose = document.querySelector('[data-search-close]');

  const openSearch = () => {
    if (!searchOverlay) return;
    closeDrawer();
    if (typeof closeCartDrawer === 'function') closeCartDrawer();
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 80);
  };
  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  searchToggles.forEach((btn) => btn.addEventListener('click', (e) => { e.stopPropagation(); openSearch(); }));
  searchClose && searchClose.addEventListener('click', closeSearch);
  // Click outside the inner form closes search
  searchOverlay && searchOverlay.addEventListener('click', (e) => {
    if (!e.target.closest('.search-overlay__inner')) closeSearch();
  });

  // ── Cart Drawer ────────────────────────────────────────────────────
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerOverlay = drawerOverlay; // reuse existing overlay
  const cartDrawerClose = document.querySelector('[data-cart-drawer-close]');
  const cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
  const cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartDrawerCount = document.querySelector('[data-cart-drawer-count]');
  const cartDrawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');

  const fmt = (cents) => {
    const sym = (window.Shopify?.currency?.active) || window.Shopify?.currency?.symbol || '$';
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  const fmtMoney = (cents) => {
    const format = window.MELY_MONEY_FORMAT || window.Shopify?.moneyFormat || '€{{amount}}';
    const amount = fmt(cents);
    // Replace Shopify money placeholders ({{amount}}, {{amount_with_comma_separator}}, etc.)
    const out = format.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    return /[$€£¥]|\bEUR\b|\bUSD\b/.test(out) ? out : '€' + amount;
  };
  const cartImageFallback = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 4 5%22%3E%3Crect width=%224%22 height=%225%22 fill=%22%23eee%22/%3E%3C/svg%3E';
  const htmlEscapeMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => htmlEscapeMap[char]);
  const normalizeImageUrl = (source) => {
    if (!source) return '';
    if (Array.isArray(source)) return normalizeImageUrl(source[0]);
    if (typeof source === 'object') {
      return normalizeImageUrl(source.url || source.src || source.image || source.featured_image || source.preview_image);
    }
    const url = String(source).trim();
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  };
  const productImageCache = new Map();
  const getProductHandle = (item) => {
    if (item.handle) return String(item.handle);
    const match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const getCartItemImage = (item) => {
    const properties = item.properties || {};
    return normalizeImageUrl(item.featured_image)
      || normalizeImageUrl(item.image)
      || normalizeImageUrl(item.variant_image)
      || normalizeImageUrl(item.product_image)
      || normalizeImageUrl(properties._mely_image || properties.mely_image);
  };
  const fetchProductImage = async (item) => {
    const itemImage = getCartItemImage(item);
    if (itemImage) return itemImage;
    const handle = getProductHandle(item);
    if (!handle) return '';
    if (productImageCache.has(handle)) return productImageCache.get(handle);

    const imagePromise = fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => normalizeImageUrl(product?.featured_image) || normalizeImageUrl(product?.images) || normalizeImageUrl(product?.image))
      .catch(() => '');
    productImageCache.set(handle, imagePromise);
    return imagePromise;
  };
  const hydrateCartDrawerImages = (cart) => {
    if (!cartDrawerBody || !cart?.items?.length) return;
    cart.items.forEach((item, index) => {
      const imageEl = cartDrawerBody.querySelector(`[data-line="${index + 1}"] [data-cart-line-image]`);
      if (!imageEl || imageEl.dataset.hasImage === 'true') return;
      fetchProductImage(item).then((imageUrl) => {
        if (!imageUrl || !document.body.contains(imageEl)) return;
        imageEl.src = imageUrl;
        imageEl.dataset.hasImage = 'true';
        if (imageEl.complete) imageEl.classList.add('is-loaded');
        else imageEl.addEventListener('load', () => imageEl.classList.add('is-loaded'), { once: true });
      });
    });
  };

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    // Close menu drawer first
    drawer && drawer.classList.remove('is-open');
    cartDrawer.classList.add('is-open');
    drawerOverlay && drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  };
  const closeCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    drawerOverlay && drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  cartToggleBtns.forEach((btn) => btn.addEventListener('click', openCartDrawer));
  cartDrawerClose && cartDrawerClose.addEventListener('click', closeCartDrawer);
  // ESC / overlay already handled above

  const refreshCartDrawer = async () => {
    if (!cartDrawerBody) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch {
      cartDrawerBody.innerHTML = '<p style="text-align:center;color:var(--color-muted);padding:2rem">' + t('cart.loadError', 'Could not load bag.') + '</p>';
    }
  };

  const renderCartDrawer = (cart) => {
    if (!cartDrawerBody) return;
    // Update badge
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (cartDrawerCount) {
      cartDrawerCount.textContent = cart.item_count || '';
      cartDrawerCount.style.display = cart.item_count > 0 ? '' : 'none';
    }
    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" style="opacity:.3;margin-bottom:1rem"><path d="M5 7h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7zM9 7V5a3 3 0 0 1 6 0v2"/></svg>
          <p>${t('cart.empty', 'Your bag is empty.')}</p>
          <a href="/collections/all" class="btn btn--primary" onclick="closeCartDrawer()">${t('cart.shopAll', 'Shop all')}</a>
        </div>`;
      cartDrawerFooter && (cartDrawerFooter.style.display = 'none');
      return;
    }
    cartDrawerBody.innerHTML = cart.items.map((item, index) => {
      const img = getCartItemImage(item);
      const title = escapeHTML(item.title || item.product_title || '');
      const productTitle = escapeHTML(item.product_title || item.title || '');
      const variantTitle = escapeHTML(item.variant_title || '');
      const itemUrl = escapeHTML(item.url || '#');
      return `
      <div class="cart-drawer-line" data-line="${index + 1}">
        <a href="${itemUrl}" onclick="closeCartDrawer()" style="display:block">
          <img class="cart-drawer-line__img" data-cart-line-image data-has-image="${img ? 'true' : 'false'}" src="${escapeHTML(img || cartImageFallback)}" onerror="this.onerror=null;this.dataset.hasImage='false';this.src='${cartImageFallback}'" alt="${title}" loading="lazy" width="80" height="100">
        </a>
        <div>
          <a href="${itemUrl}" class="cart-drawer-line__title" onclick="closeCartDrawer()">${productTitle}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-line__variant">${variantTitle}</div>` : ''}
          <div class="cart-drawer-line__bottom">
            <span class="cart-drawer-line__price">${fmtMoney(item.final_line_price)}</span>
            <div class="cart-drawer-line__qty">
              <button type="button" data-cart-line-minus="${index + 1}" aria-label="${t('cart.decreaseQuantity', 'Decrease quantity')}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-line-plus="${index + 1}" aria-label="${t('cart.increaseQuantity', 'Increase quantity')}">+</button>
            </div>
          </div>
          <button class="cart-drawer-line__remove" data-cart-line-remove="${index + 1}" type="button">${t('cart.remove', 'Remove')}</button>
        </div>
      </div>`;
    }).join('');

    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = fmtMoney(cart.items_subtotal_price);
    cartDrawerFooter && (cartDrawerFooter.style.display = '');
    hydrateCartDrawerImages(cart);
    // Attach is-loaded to dynamically injected images
    cartDrawerBody.querySelectorAll('img').forEach((img) => {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    });
  };

  // Cart drawer qty / remove
  cartDrawerBody && cartDrawerBody.addEventListener('click', async (e) => {
    const minusBtn = e.target.closest('[data-cart-line-minus]');
    const plusBtn = e.target.closest('[data-cart-line-plus]');
    const removeBtn = e.target.closest('[data-cart-line-remove]');
    if (!minusBtn && !plusBtn && !removeBtn) return;

    const line = parseInt((minusBtn || plusBtn || removeBtn).dataset.cartLineMinus
      || (plusBtn || removeBtn).dataset.cartLinePlus
      || removeBtn.dataset.cartLineRemove);
    const lineEl = cartDrawerBody.querySelector(`[data-line="${line}"]`);
    const currentQty = parseInt(lineEl?.querySelector('.cart-drawer-line__qty span')?.textContent || '1');
    let newQty = removeBtn ? 0 : (plusBtn ? currentQty + 1 : Math.max(0, currentQty - 1));

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: newQty })
      });
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch {}
  });

  // Make closeCartDrawer available globally for inline onclick
  window.closeCartDrawer = closeCartDrawer;

  // ── Product variant picker ─────────────────────────────────────────
  document.querySelectorAll('[data-product-form]').forEach((marker) => {
    const form = marker.closest('form');
    if (!form) return;
    const priceEl = form.querySelector('[data-price]');
    const compareEl = form.querySelector('[data-compare]');
    const variantInput = form.querySelector('[name="id"]');
    const variants = (() => { try { return JSON.parse(marker.dataset.variants || '[]'); } catch { return []; } })();
    const fmt = (cents) => {
      const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const format = window.MELY_MONEY_FORMAT || (window.Shopify && Shopify.moneyFormat) || '€{{amount}}';
      const out = format.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
      return /[$€£¥]|\bEUR\b|\bUSD\b/.test(out) ? out : '€' + amount;
    };
    const update = () => {
      const selected = [];
      form.querySelectorAll('[data-option]:checked').forEach((i) => selected.push(i.value));
      // Reflect the selected colour name next to its option label
      form.querySelectorAll('.option-selected[data-selected-for]').forEach((el) => {
        const pos = parseInt(el.dataset.selectedFor, 10);
        if (pos && selected[pos - 1]) el.textContent = selected[pos - 1];
      });
      const match = variants.find((v) => v.options.every((opt, idx) => opt === selected[idx]));
      if (!match || !variantInput) return;
      variantInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmt(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      // Filter the gallery to show only the selected colour's images
      const gallery = document.querySelector('.media-slides');
      if (gallery && typeof window.melyFilterGallery === 'function') {
        const colorInput = form.querySelector('[data-option-color]:checked');
        const colour = colorInput ? colorInput.value : '';
        window.melyFilterGallery(gallery, colour);
      }
    };
    form.querySelectorAll('[data-option]').forEach((i) => i.addEventListener('change', update));
    update();
  });

  // ── Marquee duplicator ─────────────────────────────────────────────
  document.querySelectorAll('[data-marquee]').forEach((track) => {
    track.innerHTML += track.innerHTML;
  });

  // ── Product gallery thumb switcher ─────────────────────────────────
  document.querySelectorAll('.product__thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product__gallery');
      if (!gallery) return;
      gallery.querySelectorAll('.product__thumb').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const mainImg = gallery.querySelector('.product__main img');
      const src = thumb.querySelector('img')?.src;
      if (mainImg && src) mainImg.src = src;
    });
  });

  // ── Animated counters (hero stats) ─────────────────────────────────
  const counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    const animateCount = (el) => {
      const target = parseFloat(el.dataset.count);
      const suffix = el.dataset.countSuffix || '';
      const duration = 1600;
      const start = performance.now();
      const decimals = (el.dataset.count.split('.')[1] || '').length;
      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        const val = target * eased;
        el.textContent = (decimals ? val.toFixed(decimals) : Math.floor(val).toLocaleString()) + suffix;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const cIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { animateCount(e.target); cIO.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach((el) => cIO.observe(el));
  }

  // ── Magnetic buttons (desktop only, respects reduced motion) ───────
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (isFinePointer && !reducedMotion) {
    document.querySelectorAll('[data-magnetic], .btn--primary, .btn--ghost').forEach((btn) => {
      const strength = 0.25;
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * strength;
        const y = (e.clientY - r.top - r.height / 2) * strength;
        btn.style.transform = `translate(${x}px, ${y}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });

    // ── Cursor follower blob — disabled
  }

  // ── Announcement bar — vertical auto-rotator ────────────────────────
  (function() {
    var slider = document.getElementById('AnnouncementSlider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var current = 0;
    function nextSlide() {
      var leaving = slides[current];
      var next = (current + 1) % slides.length;
      // animate out current
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      // after animation hide it
      setTimeout(function() { leaving.classList.remove('is-leaving'); }, 460);
      // show next
      slides[next].classList.add('is-active');
      current = next;
    }
    setInterval(nextSlide, 3500);
  })();

  // ── Hero parallax (subtle) ─────────────────────────────────────────
  const heroMedia = document.querySelector('.hero__media img');
  if (heroMedia && !reducedMotion) {
    window.addEventListener('scroll', () => {
      const y = Math.min(window.scrollY * 0.15, 80);
      heroMedia.style.transform = `translateY(${y}px) scale(1.05)`;
    }, { passive: true });
  }

  // ── Split-text reveal for hero h1 ──────────────────────────────────
  const splitTargets = document.querySelectorAll('[data-split]');
  splitTargets.forEach((el) => {
    if (el.dataset.splitDone) return;
    const text = el.innerHTML;
    // Wrap each word in a span (preserve <em> tags)
    const wrapper = document.createElement('span');
    wrapper.innerHTML = text;
    const walk = (node) => {
      if (node.nodeType === 3) {
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((w) => {
          if (!w) return;
          if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
          const span = document.createElement('span');
          span.className = 'split-word';
          span.textContent = w;
          frag.appendChild(span);
        });
        node.parentNode.replaceChild(frag, node);
      } else {
        Array.from(node.childNodes).forEach(walk);
      }
    };
    walk(wrapper);
    el.innerHTML = '';
    el.appendChild(wrapper);
    el.dataset.splitDone = '1';
    // Stagger animation
    el.querySelectorAll('.split-word').forEach((s, i) => {
      s.style.animationDelay = (0.08 * i + 0.1) + 's';
    });
  });

  // ── Scroll progress bar ────────────────────────────────────────────
  const progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress';
  document.body.appendChild(progressBar);
  const updateProgress = () => {
    const h = document.documentElement;
    const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight) || 0;
    progressBar.style.setProperty('--progress', scrolled);
  };
  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  // ── 3D tilt on product cards (desktop) ─────────────────────────────
  if (isFinePointer && !reducedMotion) {
    document.querySelectorAll('.product-card, .collection-tile').forEach((card) => {
      const max = 6; // max degrees
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        const rx = (0.5 - y) * max;
        const ry = (x - 0.5) * max;
        card.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-6px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
  }

  // ── Aurora blobs in hero ───────────────────────────────────────────
  const heroSection = document.querySelector('.hero');
  if (heroSection && !heroSection.querySelector('.aurora')) {
    const a1 = document.createElement('div');
    a1.className = 'aurora aurora--1';
    const a2 = document.createElement('div');
    a2.className = 'aurora aurora--2';
    heroSection.prepend(a1);
    heroSection.prepend(a2);
  }

  // ── Corner mark on collection tiles ────────────────────────────────
  document.querySelectorAll('.collection-tile').forEach((tile) => {
    if (tile.querySelector('.collection-tile__corner')) return;
    const corner = document.createElement('span');
    corner.className = 'collection-tile__corner';
    corner.setAttribute('aria-hidden', 'true');
    tile.appendChild(corner);
  });

  // ── Smooth anchor scroll ───────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ── Lazy-add 'is-loaded' to images for fade-in ─────────────────────
  document.querySelectorAll('img').forEach((img) => {
    if (img.complete) img.classList.add('is-loaded');
    else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
  });

  // ── Track mouse for radial glow on primary buttons ─────────────────
  document.querySelectorAll('.btn--primary').forEach((btn) => {
    btn.addEventListener('mousemove', (e) => {
      const r = btn.getBoundingClientRect();
      btn.style.setProperty('--mx', `${e.clientX - r.left}px`);
      btn.style.setProperty('--my', `${e.clientY - r.top}px`);
    });
  });

  // ── Theme toggle (light/dark) — handles multiple buttons ──────────
  const themeToggles = document.querySelectorAll('[data-theme-toggle]');
  const applyTheme = (next) => {
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('mely-theme', next); } catch {}
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', next === 'dark' ? '#0d0d10' : '#F5F2EC');
  };
  themeToggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const current = document.documentElement.getAttribute('data-theme') || 'light';
      applyTheme(current === 'dark' ? 'light' : 'dark');
    });
  });

  // ── Language switcher dropdown — handles multiple instances ────────
  const langWraps = document.querySelectorAll('[data-lang-switcher]');
  const closeAllLang = () => langWraps.forEach((w) => {
    w.classList.remove('is-open');
    const t = w.querySelector('.lang-switcher__trigger');
    if (t) t.setAttribute('aria-expanded', 'false');
  });
  langWraps.forEach((langWrap) => {
    const trigger = langWrap.querySelector('.lang-switcher__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const willOpen = !langWrap.classList.contains('is-open');
      closeAllLang();
      if (willOpen) {
        langWrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', (e) => {
    if (![...langWraps].some((w) => w.contains(e.target))) closeAllLang();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllLang();
  });
  // keep a reference to the first langWrap for the auto-detect toast below
  const langWrap = langWraps[0] || null;

  // ── Auto-detect language on first visit ────────────────────────────
  // Maps browser language to Shopify locale codes available in this theme.
  // Only triggers ONCE (uses localStorage flag) and only if browser lang
  // matches an available locale that differs from the current one.
  try {
    const ALREADY = localStorage.getItem('mely-lang-detected');
    if (!ALREADY && langWrap) {
      const available = Array.from(langWrap.querySelectorAll('button[name="locale_code"]'))
        .map((b) => b.value);
      const current = document.documentElement.lang || 'en';
      const browser = (navigator.language || 'en').toLowerCase();
      // Match: try full code first (en-US), then language only (en)
      let match = available.find((c) => c.toLowerCase() === browser);
      if (!match) {
        const short = browser.split('-')[0];
        match = available.find((c) => c.toLowerCase().split('-')[0] === short);
      }
      localStorage.setItem('mely-lang-detected', '1');
      if (match && match.toLowerCase() !== current.toLowerCase()) {
        const btn = langWrap.querySelector(`button[name="locale_code"][value="${match}"]`);
        if (btn) {
          // Soft prompt: show a small toast
          const toast = document.createElement('div');
          toast.className = 'lang-toast';
          const langName = btn.querySelector('span')?.textContent || match;
          toast.innerHTML = `
            <span>View in <strong>${langName}</strong>?</span>
            <button class="lang-toast__yes">Yes</button>
            <button class="lang-toast__no" aria-label="Dismiss">×</button>
          `;
          document.body.appendChild(toast);
          requestAnimationFrame(() => toast.classList.add('is-visible'));
          toast.querySelector('.lang-toast__yes').addEventListener('click', () => {
            btn.closest('form').requestSubmit ? btn.closest('form').requestSubmit(btn) : btn.click();
          });
          toast.querySelector('.lang-toast__no').addEventListener('click', () => {
            toast.classList.remove('is-visible');
            setTimeout(() => toast.remove(), 400);
          });
          setTimeout(() => {
            toast.classList.remove('is-visible');
            setTimeout(() => toast.remove(), 400);
          }, 8000);
        }
      }
    }
  } catch {}

  // ── Cart page qty +/− buttons ──────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('[data-cart-page-minus]');
    const plus = e.target.closest('[data-cart-page-plus]');
    if (!minus && !plus) return;
    const btn = minus || plus;
    const line = parseInt(btn.dataset.cartPageMinus || btn.dataset.cartPagePlus);
    const row = btn.closest('.cart-line');
    const input = row?.querySelector('[data-qty]');
    if (!input || !line) return;
    const val = parseInt(input.value) || 1;
    const newQty = plus ? val + 1 : Math.max(0, val - 1);
    input.value = newQty;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: newQty })
      });
      window.location.reload();
    } catch {}
  });

  // ── Touch swipe for all media-slides ─────────────────────────────
  document.querySelectorAll('.media-slides').forEach(function(wrap) {
    if (!wrap.id) return;
    var id = wrap.id;
    var startX = 0;
    wrap.addEventListener('touchstart', function(e) {
      startX = e.changedTouches[0].screenX;
    }, { passive: true });
    wrap.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) melySlide(id, diff > 0 ? 1 : -1);
    }, { passive: true });
  });

  // ── Product page form → AJAX add + open cart drawer ───────────────
  document.querySelectorAll('form.product__form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const addBtn = form.querySelector('[name="add"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) { form.submit(); return; }
      const origHTML = addBtn?.innerHTML;
      if (addBtn) { addBtn.textContent = '...'; addBtn.disabled = true; }
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        if (!r.ok) throw new Error();
        openCartDrawer();
      } catch { form.submit(); }
      finally {
        setTimeout(() => { if (addBtn) { addBtn.innerHTML = origHTML; addBtn.disabled = false; } }, 2500);
      }
    });
  });
})();
